import "../styles/cgu.scss"


function Utilisation(){

return (

   <div className="blocpage">

    <h1>Conditions Générales d’Utilisation (CGU)</h1>


<h2>Article 1 – Objet</h2>
<p>
Les présentes Conditions Générales d’Utilisation ont pour objet de définir les modalités d’utilisation de la plateforme éditée par BMDev, permettant la mise en relation entre des particuliers (ci-après “Clients”) et des professionnels du bricolage (ci-après “Professionnels”).<br></br>

La plateforme agit uniquement en qualité d’intermédiaire technique.
</p>
<h2>Article 2 – Inscription</h2>

<h3>2.1 Clients</h3>
<p>
L’inscription est gratuite.<br></br>
Le Client s’engage à fournir des informations exactes, complètes et à jour.
</p>

<h3>2.2 Professionnels</h3>
<p>
L’accès aux demandes est soumis à un abonnement mensuel de 19€ TTC.<br></br>

Le Professionnel s’engage à :<br></br>

Être légalement déclaré<br></br>
Disposer d’un numéro SIRET valide<br></br>
Être titulaire d’une assurance responsabilité civile professionnelle<br></br>

La plateforme se réserve le droit de demander tout justificatif.
</p>

<h2>Article 3 – Rôle de la plateforme</h2>
<p>
La plateforme :<br></br>

Met en relation les utilisateurs<br></br>
Permet un échange via une messagerie interne<br></br>
Permet la validation d’un accord entre les parties<br></br>

La plateforme :<br></br>

N’intervient pas dans la négociation<br></br>
N’intervient pas dans le paiement<br></br>
N’est pas partie au contrat conclu entre les utilisateurs<br></br>
</p>

<h2>Article 4 – Accès aux coordonnées</h2>
<p>
L’accès aux coordonnées personnelles (téléphone, email) est conditionné à la validation d’un accord entre les utilisateurs via la plateforme.<br></br>

Toute tentative de contournement de la plateforme pourra entraîner la suspension du compte.
</p>

<h2>Article 5 – Responsabilité</h2>
<p>
La responsabilité de la plateforme ne saurait être engagée en cas :<br></br>

De mauvaise exécution d’une prestation<br></br>
De litige entre utilisateurs<br></br>
De dommages causés par un Professionnel<br></br>
De non-paiement entre parties<br></br>

Les utilisateurs contractent directement entre eux sous leur seule responsabilité.<br></br>

La plateforme ne garantit ni la qualité des prestations, ni la solvabilité des utilisateurs, ni la bonne exécution des travaux.
</p>
<h2>Article 6 – Abonnement</h2>
<p>
L’abonnement :<br></br>

Est mensuel<br></br>
Est reconduit automatiquement sauf résiliation<br></br>
Peut être résilié à tout moment depuis l’espace utilisateur<br></br>
Ne donne lieu à aucun remboursement pour le mois en cours<br></br>

Les paiements sont sécurisés et gérés par un prestataire tiers spécialisé (ex : Stripe).<br></br>
La plateforme ne stocke aucune donnée bancaire.<br></br>

La plateforme se réserve le droit de suspendre un compte en cas de non-respect des CGU ou de défaut de paiement.
</p>

<h2>Article 7 – Messagerie</h2>
<p>
La plateforme met à disposition un système de messagerie interne.<br></br>

Les échanges peuvent être modérés ou analysés afin de garantir la sécurité des utilisateurs et prévenir les fraudes.
</p>

<h2>Article 8 – Système de notation</h2>
<p>
Les utilisateurs peuvent s’évaluer mutuellement.<br></br>

Tout avis abusif, diffamatoire ou frauduleux pourra être supprimé sans préavis.
</p>

<h2>Article 9 – Comportements interdits</h2>
<p>
Il est interdit aux utilisateurs de :<br></br>

Fournir de fausses informations<br></br>
Contourner la plateforme pour éviter un abonnement<br></br>
Publier des contenus illégaux ou frauduleux<br></br>
Porter atteinte aux autres utilisateurs (harcèlement, menaces, etc.)
</p>

<h2>Article 10 – Suspension / suppression de compte</h2>
<p>
La plateforme se réserve le droit de suspendre ou supprimer un compte, sans préavis, en cas de non-respect des présentes CGU.
</p>

<h2>Article 11 – Données personnelles</h2>
<p>
Les données collectées sont nécessaires au fonctionnement de la plateforme.<br></br>

Conformément à la réglementation en vigueur, les utilisateurs disposent :<br></br>

D’un droit d’accès<br></br>
D’un droit de rectification<br></br>
D’un droit de suppression<br></br>

Les données ne sont pas revendues.<br></br>

Pour plus d’informations, consulter la Politique de confidentialité.
</p>

<h2>Article 12 – Disponibilité du service</h2>
<p>
La plateforme ne garantit pas un accès continu, sans interruption ou sans erreur au service.
</p>

<h2>Article 13 – Modification des CGU</h2>
<p>
La plateforme se réserve le droit de modifier les présentes CGU à tout moment.<br></br>

Les utilisateurs seront informés en cas de modification.
</p>

<h2>Article 14 – Droit applicable et litiges</h2>
<p>
Les présentes CGU sont régies par le droit français.<br></br>

Tout litige relève de la compétence des tribunaux du siège social de l’éditeur.
</p>

<h2>Article 15 – Contact</h2>

<p>
Pour toute question, vous pouvez contacter :

BMDev
Email : briconnectapp@gmail.com
</p>
   </div>

    
)
}

export default Utilisation